export { default as MainLayout } from './MainLayout';
export { default as PublicLayout } from './PublicLayout';
export { default as MasterLayout } from './MasterLayout';



// WEBPACK FOOTER //
// ./src/core/layouts/index.js